import simpleParallax from 'simple-parallax-js';

export default class myParallax {

    boxDesc() {
        var images = document.querySelectorAll('.box-desc__bg');
        new simpleParallax(images, {
            overflow: true,
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 1.5
        });
        
        var desc = document.querySelectorAll('.box-desc__desc');
        new simpleParallax(desc, {
            overflow: true,
            orientation: 'down',
            transition: 'cubic-bezier(0,0,0,1)'
        });
    }


    about() {
        var about_image = document.querySelectorAll('.ta-about__image');
        new simpleParallax(about_image, {
            overflow: true,
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 1.2
        });
    }


    team() {
        var team_title = document.querySelectorAll('.ta-team__header');
        new simpleParallax(team_title, {
            overflow: true,
            orientation: 'down',
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 2
        });
    }


    recruiter() {
        var img = document.querySelectorAll('.sj-recruiter__bg');
        new simpleParallax(img, {
            overflow: true,
            orientation: 'down',
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 1.4
        });
    }
  
    init() {
        if (window.innerWidth > 991) {
            document.querySelector('.box-desc') ? this.boxDesc() : null;
            document.querySelector('.ta-about') ? this.about() : null;
            document.querySelector('.ta-team') ? this.team() : null;
            document.querySelector('.sj-recruiter') ? this.recruiter() : null;
        }
    }
}